import { render } from "./Index.vue?vue&type=template&id=60d1fba2"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Auth/OTP/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60d1fba2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60d1fba2', __exports__)) {
    api.reload('60d1fba2', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=60d1fba2", () => {
    api.rerender('60d1fba2', render)
  })

}


export default __exports__